"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1489],{

/***/ 79161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pageNav_PageNav; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(13706);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(21218);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(88673);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/layout/pageNav/PageNav.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: ",
        ";\n  padding-right: ",
        ";\n\n  &.hiddenPageNav {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n\n    li {\n      padding: ",
        ";\n    }\n\n    a {\n      display: block;\n      width: ",
        ";\n      height: ",
        ";\n      border-radius: ",
        ";\n      background-color: ",
        ";\n      border: ",
        " solid transparent;\n      background-clip: padding-box;\n      box-sizing: content-box;\n      transition: 0.3s;\n\n      &:hover {\n        border-color: ",
        ";\n      }\n\n      &.is-active {\n        background-color: ",
        ";\n        border-color: ",
        ";\n\n        &:hover {\n          border-color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: ",
        ";\n\n  a {\n    width: ",
        ";\n    height: ",
        ";\n    color: ",
        " !important;\n    margin-top: ",
        ";\n    transition: 0.3s;\n\n    &:hover {\n      color: ",
        " !important;\n    }\n\n    .activeHero & {\n      color: ",
        " !important;\n\n      &:hover {\n        color: ",
        " !important;\n      }\n    }\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledPageNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-bddc6e8-0"
})(_templateObject(), (0,theme/* zindex */.Y0)("pageNav"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("midnight_700"), (0,theme/* color */.$_)("selected"));
var StyledPageNavArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bddc6e8-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_600"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/layout/pageNav/PageNav.js
/* eslint-disable no-undef */ 












var PageNav = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PageNav, Component);
    var _super = (0,_create_super/* default */.Z)(PageNav);
    function PageNav(props) {
        (0,_class_call_check/* default */.Z)(this, PageNav);
        var _this;
        var ref, ref1;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "updateActiveSection", function(e) {
            var sectionPrev;
            var sectionNext;
            var activeSectionIndex;
            var Allsections = _this.props.sections;
            var totalSections = Allsections.length - 1;
            Allsections.map(function(element, index) {
                if (element.section === e) {
                    activeSectionIndex = index;
                }
            });
            if (activeSectionIndex === 0) {
                var ref, ref1;
                sectionPrev = (ref = Allsections[0]) === null || ref === void 0 ? void 0 : ref.section;
                sectionNext = (ref1 = Allsections[1]) === null || ref1 === void 0 ? void 0 : ref1.section;
            } else if (activeSectionIndex < totalSections) {
                var ref2, ref3;
                sectionPrev = (ref2 = Allsections[activeSectionIndex - 1]) === null || ref2 === void 0 ? void 0 : ref2.section;
                sectionNext = (ref3 = Allsections[activeSectionIndex + 1]) === null || ref3 === void 0 ? void 0 : ref3.section;
            } else {
                var ref4, ref5;
                sectionPrev = (ref4 = Allsections[totalSections - 1]) === null || ref4 === void 0 ? void 0 : ref4.section;
                sectionNext = (ref5 = Allsections[totalSections]) === null || ref5 === void 0 ? void 0 : ref5.section;
            }
            _this.setState({
                sectionPrev: sectionPrev,
                sectionNext: sectionNext
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleScroll", function() {
            if (!document.querySelector("#hero")) {
                return;
            }
            var heroBottom = document.querySelector("#hero").getBoundingClientRect().bottom;
            var bottomBarTop = document.querySelector("#bottom-bar") ? document.querySelector("#bottom-bar").getBoundingClientRect().top : false;
            var arrowsTop = document.querySelector("#pageNavArrows").getBoundingClientRect().top;
            if (heroBottom > arrowsTop || bottomBarTop && arrowsTop > bottomBarTop) {
                _this.setState({
                    activeHero: true
                });
            } else {
                _this.setState({
                    activeHero: false
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleResize", function() {
            var pageNav = document.querySelector("#page-nav");
            var safetyHeight = 120; //extra room for top and bottom bars
            if (!pageNav) {
                return;
            }
            if (pageNav.offsetHeight > window.innerHeight - safetyHeight) {
                _this.setState({
                    hiddenPageNav: true
                });
            } else {
                _this.setState({
                    hiddenPageNav: false
                });
            }
        });
        _this.state = {
            hiddenPageNav: false,
            activeHero: false,
            sectionPrev: (ref = _this.props.sections[0]) === null || ref === void 0 ? void 0 : ref.section,
            sectionNext: (ref1 = _this.props.sections[1]) === null || ref1 === void 0 ? void 0 : ref1.section
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(PageNav, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("scroll", this.handleScroll);
                window.addEventListener("resize", this.handleResize);
                this.handleScroll();
                this.handleResize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.handleScroll);
                window.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref;
                if (((ref = this.props.sections) === null || ref === void 0 ? void 0 : ref.length) <= 1) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageNav, {
                    className: "".concat(this.state.activeHero ? "activeHero" : "", " ").concat(this.state.hiddenPageNav ? "hiddenPageNav" : ""),
                    "aria-label": this.props.navLabel,
                    id: "page-nav",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: this.props.sections.map(function(s, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                        content: s.tooltip,
                                        direction: "left",
                                        distance: 18,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            activeClass: "is-active",
                                            to: s.section,
                                            href: "#".concat(s.section),
                                            "aria-label": s.tooltip,
                                            title: s.tooltip,
                                            spy: true,
                                            id: "pagenav-link-".concat(s.section),
                                            onSetActive: function() {
                                                _this.updateActiveSection(s.section);
                                            },
                                            offset: i === 0 ? -64 : 0
                                        })
                                    })
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageNavArrows, {
                            id: "pageNavArrows",
                            children: [
                                this.state.sectionPrev && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                    to: this.state.sectionPrev,
                                    href: "#".concat(this.state.sectionPrev),
                                    "aria-label": this.props.prevLabel,
                                    title: this.props.prevLabel,
                                    id: "pagenav-prev",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faArrowSquareUp */.xGL,
                                        "aria-hidden": "true"
                                    })
                                }),
                                this.state.sectionNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                    to: this.state.sectionNext,
                                    href: "#".concat(this.state.sectionNext),
                                    "aria-label": this.props.nextLabel,
                                    title: this.props.nextLabel,
                                    id: "pagenav-next",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faArrowSquareDown */.KGH,
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return PageNav;
}(react.Component);
/* harmony default export */ var pageNav_PageNav = (PageNav);


/***/ }),

/***/ 27805:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);